﻿import { SKUDetails } from 'pages/sku_management/components/SKUDetails';
import { SKUContent } from 'pages/sku_management/components/SKUContent';
import { GMetrixTabs, GMetrixTabsTab } from 'components/GMetrixTabs';
import { useSKUDetails } from 'pages/sku_management/context';
import { FormattedMessage } from 'react-intl';
import { useStickyTabIndex } from 'hooks';

export function SKUProfile() {

    const { openTabIndex, pageContext, setSubTabIndex, subTabIndex } = useSKUDetails();

    // Remember the active sub-tab per SKU across refreshes.
    useStickyTabIndex({
        entityId: pageContext?.Id,
        onRestore: index => {

            const copyOfSubTabIndex = [...subTabIndex];
            copyOfSubTabIndex[openTabIndex - 1] = index;
            setSubTabIndex(copyOfSubTabIndex);

        },
        scope: 'sku',
        value: subTabIndex[openTabIndex - 1] ?? 0
    });

    const tabNavigationClick = (value: number) => {

        const copyOfSubTabIndex = [...subTabIndex];
        copyOfSubTabIndex[openTabIndex - 1] = value;
        setSubTabIndex(copyOfSubTabIndex);

    };

    return (
        <GMetrixTabs
            unmountOnExit
            onSelect={i => tabNavigationClick(i)}
            selected={subTabIndex[openTabIndex - 1]}
        >
            <GMetrixTabsTab
                title={(
                    <div>
                        <FormattedMessage defaultMessage="Details" id="details.7799b923" />
                    </div>
                )}
            >
                <SKUDetails />
            </GMetrixTabsTab>
            <GMetrixTabsTab
                title={(
                    <div>
                        <FormattedMessage defaultMessage="Content" id="content.e305279d" />
                    </div>
                )}
            >
                <SKUContent />
            </GMetrixTabsTab>
        </GMetrixTabs>
    );

}
